import React from 'react';
import loadable from '@loadable/component';
import { LoadingPage } from 'components/core/LoadingPage';

const options = {
	fallback: <LoadingPage />,
};

const FacilityPageV2 = loadable(
	() =>
		import(
			/* webpackChunkName: "FacilityPageV2" */ '../FacilityPageV2/FacilityPageV2'
		),
	options,
);

export default function FacilityPageWrapper(props) {
	return <FacilityPageV2 {...props} />;
}
